// สร้างไฟล์ใหม่ที่ src/components/LoginScreen.jsx

import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import * as FiIcons from "react-icons/fi";
import SafeIcon from "../common/SafeIcon";
import Base64ToWavConverter from "./Base64ToWavConverter";

const { FiMail, FiLock, FiLogIn, FiLoader } = FiIcons;

const LoginScreen = ({
  onLoginSubmit,
  error,
  isLoading,
  isVideoError,
  setIsVideoError, // <-- 1. รับ props ใหม่
}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isLoading) return;
    onLoginSubmit({ email, password });
  };

  return (
    <div className="w-full max-w-sm flex flex-col items-center text-center">
      {/* --- 3. นำ Header Section ที่คุณต้องการมาวางที่นี่ --- */}
      <motion.div
        className="w-full mb-8" // <-- เพิ่ม mb-8 เพื่อเว้นระยะห่าง
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        {isVideoError ? (
          <img
            src="/images/yy_success_zoom.jpg"
            alt="ยั่งยืนย่อ Logo"
            className="w-32 h-32 mx-auto mb-6 rounded-2xl ring-2 ring-green-700 ring-offset-2 ring-offset-slate-50"
          />
        ) : (
          <video
            autoPlay
            loop
            muted
            playsInline
            title="ยั่งยืนย่อ Logo Animation"
            className="w-32 h-32 mx-auto mb-6 rounded-2xl object-cover scale-110 ring-2 ring-green-700 ring-offset-2 ring-offset-slate-50"
            onError={() => setIsVideoError(true)}
          >
            <source src="/vdo/yy_landing_vdo.MP4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        )}

        <h1 className="text-3xl font-bold text-green-700 tracking-wide">
          ยั่งยืน'ย่อ'
        </h1>
        <p className="text-slate-600 mt-2">
          กรุณาเข้าสู่ระบบเพื่อเริ่ม "ย่อ" ข้อมูลของคุณ
        </p>
      </motion.div>

      {/* --- 4. การ์ด Login เดิม (ปรับแก้เล็กน้อย) --- */}
      <motion.div
        className="w-full bg-white p-6 sm:p-8 rounded-2xl shadow-xl"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1, transition: { delay: 0.2 } }}
      >
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="relative">
            <SafeIcon
              icon={FiMail}
              className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 w-5 h-5"
            />
            <input
              type="email"
              placeholder="อีเมล"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full p-3 pl-12 bg-slate-100 border-2 border-transparent rounded-lg focus:outline-none focus:border-green-500 focus:bg-white transition-all"
            />
          </div>

          <div className="relative">
            <SafeIcon
              icon={FiLock}
              className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 w-5 h-5"
            />
            <input
              type="password"
              placeholder="รหัสผ่าน"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full p-3 pl-12 bg-slate-100 border-2 border-transparent rounded-lg focus:outline-none focus:border-green-500 focus:bg-white transition-all"
            />
          </div>

          <div className="text-right">
            <a
              href="#"
              className="text-xs font-medium text-green-600 hover:underline"
            >
              ลืมรหัสผ่าน?
            </a>
          </div>

          <AnimatePresence>
            {error && (
              <motion.p
                className="text-red-500 text-sm bg-red-50 p-2 rounded-lg text-center"
                initial={{ y: -10, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
              >
                {error}
              </motion.p>
            )}
          </AnimatePresence>

          <motion.button
            type="submit"
            disabled={isLoading}
            className="w-full p-3 bg-green-600 text-white rounded-lg font-semibold text-base shadow-lg hover:bg-green-700 disabled:bg-slate-300 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            whileTap={{ scale: 0.98 }}
          >
            {isLoading ? (
              <>
                <FiLoader className="w-5 h-5 animate-spin" />
                <span>กำลังตรวจสอบ...</span>
              </>
            ) : (
              <>
                <FiLogIn className="w-5 h-5" />
                <span>เข้าสู่ระบบ</span>
              </>
            )}
          </motion.button>
        </form>

        {/* Register Button */}
        <div className="mt-6 pt-4 border-t border-slate-200">
          <motion.button
            type="button"
            onClick={() => window.open('https://99ssconsult.com/company-profile/view?openExternalBrowser=1', '_blank')}
            className="w-full p-3 bg-slate-100 text-slate-700 rounded-lg font-semibold text-base border-2 border-slate-200 hover:bg-slate-200 hover:border-slate-300 transition-all flex items-center justify-center gap-2"
            whileTap={{ scale: 0.98 }}
          >
            <SafeIcon
              icon={FiIcons.FiUserPlus}
              className="w-5 h-5"
            />
            <span>กรุณาติดต่อ สมัครสมาชิก</span>
          </motion.button>
        </div>

       {/*  <Base64ToWavConverter /> */}
      </motion.div>
    </div>
  );
};

export default LoginScreen;
